import gsap from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const DoubleHeightModule = () => {
  if (document.querySelectorAll(".double-height-module").length < 1) {
    return;
  }

  const network = document.querySelector(".double-height-module .network");

  gsap.to(network, { opacity: 1, duration: 2, ease: "power2.inOut" }, 0);

  function createParallaxTimeline(
    triggerSelector,
    startYPercent,
    endYPercent,
    scaleTo,
  ) {
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: triggerSelector,
        scrub: 1,
        pin: false,
      },
    });

    tl.fromTo(
      triggerSelector,
      {
        yPercent: startYPercent,
        scale: 1,
        ease: "none",
      },
      {
        yPercent: endYPercent,
        scale: scaleTo,
        ease: "none",
      },
    );

    return tl;
  }

  function parallaxEffect() {
    network ? createParallaxTimeline(network, -9, 9, 1) : null;
  }

  parallaxEffect();
};

export default DoubleHeightModule;
